import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TheSeatEmbedCollectionWidget } from './TheSeatEmbedCollectionWidget'

export const SeatEmbedWidgetCollectionRegistration =
    createRegisterableComponent('election-seat-embed-collection-widget', (props:{}, services) => {
        return <TheSeatEmbedCollectionWidget imageBaseUrl={services.config.imageBaseUrl} />
    })
